import { create } from "zustand";
import type { User } from "../types";

interface AppState {
  // Auth
  user: User | null;
  orgId: string | null;
  setUser: (user: User | null) => void;
  setOrgId: (orgId: string | null) => void;

  // Global UI
  sidebarCollapsed: boolean;
  setSidebarCollapsed: (v: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  user: null,
  orgId: null,
  setUser: (user) => set({ user }),
  setOrgId: (orgId) => set({ orgId }),

  sidebarCollapsed: false,
  setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
}));
